import { inTab, type CommissionTab } from '@clim/domain';
import { useState } from 'react';
import { currentPeriod, EntryList, ExportButtons, PeriodPicker, Totals } from '../components/Commissions';
import { useEngine, useReady } from '../lib/session';

const TABS: [CommissionTab, string][] = [
  ['global', 'Global'],
  ['sale', 'Ventes'],
  ['install', 'Poses'],
];

/**
 * Mes commissions / rémunérations (§11) : vue permanente du mois (total, à valider, validé, payé),
 * détail par dossier / client ; profil mixte : onglets Global / Ventes / Poses bien séparés.
 * Disponible hors ligne (données synchronisées) ; seules MES lignes sont sur l'appareil.
 */
export function CommissionsPage() {
  const engine = useEngine();
  const { me } = useReady();
  const [period, setPeriod] = useState(currentPeriod());
  const mine = engine.list('commission').filter((c) => c.beneficiaryId === me.user.id);
  const mixed = (me.roles.includes('commercial') && me.roles.includes('technicien')) || (mine.some((c) => c.kind === 'sale') && mine.some((c) => c.kind === 'install'));
  const [tab, setTab] = useState<CommissionTab>('global');
  const inPeriod = mine.filter((c) => c.period === period && inTab(c, mixed ? tab : 'global')).sort((a, b) => a.earnedOn.localeCompare(b.earnedOn) || (a.dossierReference ?? '').localeCompare(b.dossierReference ?? ''));
  return (
    <div>
      <div className="page-head">
        <h1>{me.roles.includes('technicien') && !me.roles.includes('commercial') ? 'Mes rémunérations' : 'Mes commissions'}</h1>
        <PeriodPicker period={period} onChange={setPeriod} />
      </div>
      {mixed && (
        <div className="chips tabs-mixed" role="tablist" aria-label="Activité">
          {TABS.map(([k, l]) => (
            <button key={k} type="button" role="tab" aria-selected={tab === k} className={`chip tab-${k}${tab === k ? ' on' : ''}`} onClick={() => setTab(k)}>
              {l}
            </button>
          ))}
        </div>
      )}
      <div className={`card commission-card tab-${mixed ? tab : 'global'}`}>
        <Totals entries={inPeriod} />
        {mixed && tab === 'global' && (
          <p className="muted">
            Dont ventes : {fmt(inPeriod.filter((c) => inTab(c, 'sale')))} · dont poses / entretiens : {fmt(inPeriod.filter((c) => inTab(c, 'install')))}
          </p>
        )}
        <ExportButtons period={period} />
      </div>
      <div className="card">
        <h2>Détail par dossier</h2>
        <EntryList entries={inPeriod} />
      </div>
    </div>
  );
}

const fmt = (list: { amountCents: number; status: string }[]) =>
  (list.filter((c) => c.status !== 'cancelled').reduce((s, c) => s + c.amountCents, 0) / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
